import { render, staticRenderFns } from "./laser-form-designer.vue?vue&type=template&id=b77a204c&scoped=true&"
import script from "./laser-form-designer.vue?vue&type=script&lang=js&"
export * from "./laser-form-designer.vue?vue&type=script&lang=js&"
import style0 from "./laser-form-designer.vue?vue&type=style&index=0&id=b77a204c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77a204c",
  null
  
)

export default component.exports